'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('@arreeba/ristoranti-lib/lib/constants');

var _cart = require('@arreeba/ristoranti-lib/lib/cart');

var _cart2 = _interopRequireDefault(_cart);

var _constants2 = require('../constants');

var _time = require('./time');

var _time2 = _interopRequireDefault(_time);

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var formatString = function formatString(type, amount) {
  if (type === _constants.VOUCHER_FORMAT_PERCENTAGE) {
    return amount + '%';
  }

  if (type === _constants.VOUCHER_FORMAT_ABSOLUTE) {
    return _i18n2.default.formatPrice(amount);
  }

  return '';
};

var voucherHasMessage = function voucherHasMessage(voucher) {
  return voucher && voucher.message && voucher.message.length > 0;
};

var format = function format(voucher, localized) {
  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'it';

  if (!voucher) {
    return null;
  }

  var title = voucher.discount.format === _constants.VOUCHER_FORMAT_FREE_ITEM ? localized.FREE_ITEM : localized.DISCOUNT;
  return {
    title: title,
    subtitle: formatString(voucher.discount.format, voucher.discount.amount),
    message: voucher.message,
    validityPeriod: {
      from: _time2.default.toLocalHumanDate(voucher.validityPeriod.from, lang),
      to: _time2.default.toLocalHumanDate(voucher.validityPeriod.to, lang)
    }
  };
};

var isVoucherUsable = function isVoucherUsable(voucherData) {
  var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!voucherData) {
    return false;
  }
  var validity = voucherData.validityPeriod;
  var isValid = _time2.default.currentDateInRange({ fromISO: validity.from, toISO: validity.to }, currentDate);
  var notRedeemed = voucherData.instance.redeemed !== true;
  var notInvalidated = voucherData.instance.invalidated !== true;
  return isValid && notRedeemed && notInvalidated;
};

var isVoucherAssigned = function isVoucherAssigned(voucherData) {
  var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!voucherData) {
    return false;
  }
  var validity = voucherData.validityPeriod;
  var isValid = _time2.default.currentDateIsBefore(validity.to, currentDate);
  var notRedeemed = voucherData.instance.redeemed !== true;
  var notInvalidated = voucherData.instance.invalidated !== true;
  return isValid && notRedeemed && notInvalidated;
};

var voucherForService = function voucherForService(voucherArray, moduleName, serviceName) {
  return _lodash2.default.filter(voucherArray, function (v) {
    var module = _lodash2.default.find(v.constraints.modules, { module: moduleName });
    if (!module) {
      return false;
    }
    var service = _lodash2.default.find(module.services, { name: serviceName });
    if (!service) {
      return false;
    }
    return module && service.active && isVoucherUsable(v);
  });
};

var getVoucherWithId = function getVoucherWithId(voucherArray, id) {
  return _lodash2.default.find(voucherArray, { instance: { id: id } });
};

var cartTotalWithVoucher = function cartTotalWithVoucher(cart, extraCosts, selectedVoucher, voucherInstances) {
  if (selectedVoucher === _constants2.ORDER_NO_VOUCHER || !voucherInstances || voucherInstances.length === 0) {
    return _cart2.default.total(cart, extraCosts);
  }
  var voucherData = getVoucherWithId(voucherInstances, selectedVoucher);
  // extra check, voucherData should always be at this point
  if (!voucherData) {
    return _cart2.default.total(cart, extraCosts);
  }
  return _cart2.default.total(cart, [].concat(_toConsumableArray(extraCosts), [_cart2.default.extraCostFromVoucher(voucherData, cart)]));
};

var orderModuleForVoucher = function orderModuleForVoucher(voucherData) {
  return _lodash2.default.find(voucherData.constraints.modules, { module: 'order' });
};

var voucherActiveForOrder = function voucherActiveForOrder(voucherData) {
  var module = orderModuleForVoucher(voucherData);
  if (!module) {
    return false;
  }
  return _lodash2.default.find(module.services, { name: _constants2.ORDER_TYPE_DELIVERY, active: true }) || _lodash2.default.find(module.services, { name: _constants2.ORDER_TYPE_TAKEAWAY, active: true });
};

exports.default = {
  voucherForService: voucherForService,
  format: format,
  getVoucherWithId: getVoucherWithId,
  cartTotalWithVoucher: cartTotalWithVoucher,
  voucherActiveForOrder: voucherActiveForOrder,
  orderModuleForVoucher: orderModuleForVoucher,
  isVoucherUsable: isVoucherUsable,
  isVoucherAssigned: isVoucherAssigned,
  voucherHasMessage: voucherHasMessage
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/voucher.js
// module id = 33
// module chunks = 0